(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _Lightsaber = require('./modules/Lightsaber.js');

var _AudioEffect = require('./modules/AudioEffect.js');

var $ = document.querySelector.bind(document);

var lightSaber = new _Lightsaber.Lightsaber();
var lightSaberElem = lightSaber.elem;

var audio = new _AudioEffect.AudioEffect();

var createdPlayerRight = null;
var createdPlayerLeft = null;

var firstClick = true;

lightSaberElem.addEventListener('click', function () {

    if (lightSaber.state) {
        lightSaber.elemimg.src = lightSaber.pathOff;
        lightSaber.setState(false);
        movement("off");
    } else {
        lightSaber.elemimg.src = lightSaber.pathOn;
        lightSaber.setState(true);
        movement("on");
    }

    //I had to create / play some audios dynamically on the first click, because on mobile, some browsers do not accept to trigger audio, so it's a way to turn it on
    if (firstClick) {
        createdPlayerRight = new Audio('./audio/right.mp3');
        createdPlayerRight.muted = true;

        createdPlayerLeft = new Audio('./audio/left.mp3');
        createdPlayerLeft.muted = true;

        createdPlayerRight.play();
        createdPlayerRight.play();

        createdPlayerLeft.muted = false;
        createdPlayerRight.muted = false;

        firstClick = false;
    }
});

var logMovement = $('header h1');

if (window.DeviceOrientationEvent) {
    var sinal = 0;
    window.addEventListener('deviceorientation', function (event) {
        var movementGamma = event.gamma;

        if (lightSaber.state) {
            if (movementGamma > 25) {
                movement("right");
            } else if (movementGamma < -25) {
                movement("left");
            } else {
                movement("stopped");
            }
        }
    });
}

var previousDirection = "";

var movement = function movement(direction) {

    if (direction !== previousDirection) {
        switch (direction) {
            case "on":
                lightSaber.setState(true);
                audio.on.play();
                logMovement.innerHTML = "on";
                break;
            case "off":
                lightSaber.setState(false);
                audio.off.play();
                logMovement.innerHTML = "off";
                break;
            case "right":
                createdPlayerRight.play();
                logMovement.innerHTML = "right";
                break;
            case "left":
                createdPlayerLeft.play();
                logMovement.innerHTML = "left";
                break;
            case "stopped":
                logMovement.innerHTML = "stopped";
                break;
            default:
                lightSaber.setState(false);
                audio.off.play();
        }
        previousDirection = direction;
    }
};

},{"./modules/AudioEffect.js":2,"./modules/Lightsaber.js":3}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AudioEffect = exports.AudioEffect = function () {
    function AudioEffect() {
        _classCallCheck(this, AudioEffect);

        var $ = document.querySelector.bind(document);
        this._on = $('.audio#on');
        this._off = $('.audio#off');
    }

    _createClass(AudioEffect, [{
        key: 'player',
        get: function get() {
            return this._player;
        }
    }, {
        key: 'on',
        get: function get() {
            return this._on;
        }
    }, {
        key: 'off',
        get: function get() {
            return this._off;
        }
    }, {
        key: 'right',
        get: function get() {
            return this._right;
        }
    }, {
        key: 'left',
        get: function get() {
            return this._left;
        }
    }]);

    return AudioEffect;
}();

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Lightsaber = exports.Lightsaber = function () {
    function Lightsaber() {
        _classCallCheck(this, Lightsaber);

        var $ = document.querySelector.bind(document);
        this._on = false;
        this._elem = $('.lightsaber');
        this._elemimg = $('.lightsaber img');
        this._pathOn = "./img/lightsaber-on.png";
        this._pathOff = "./img/lightsaber.png";
    }

    _createClass(Lightsaber, [{
        key: 'setState',
        value: function setState(state) {
            this._on = state;
        }
    }, {
        key: 'state',
        get: function get() {
            return this._on;
        }
    }, {
        key: 'elem',
        get: function get() {
            return this._elem;
        }
    }, {
        key: 'elemimg',
        get: function get() {
            return this._elemimg;
        }
    }, {
        key: 'pathOn',
        get: function get() {
            return this._pathOn;
        }
    }, {
        key: 'pathOff',
        get: function get() {
            return this._pathOff;
        }
    }]);

    return Lightsaber;
}();

},{}]},{},[1])
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
